const t = "_stepperDot_1ntuu_1", e = "_stepperDotChild_1ntuu_4", p = "_activeStepperDotChild_1ntuu_7", s = "_small_1ntuu_10", o = "_medium_1ntuu_13", _ = {
  stepperDot: t,
  stepperDotChild: e,
  activeStepperDotChild: p,
  small: s,
  medium: o
};
export {
  p as activeStepperDotChild,
  _ as default,
  o as medium,
  s as small,
  t as stepperDot,
  e as stepperDotChild
};
//# sourceMappingURL=StepperDot.module.scss.js.map
